import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { IgxGridModule } from '@infragistics/igniteui-angular';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Gridster, GridsterItem } from 'angular-gridster2';

import { ComponentsModule } from '../components/components.module';
import { MaterialModule } from '../core/material.module';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { GeneralSettingsComponent } from './account/general-settings/general-settings.component';
import { MyProfileComponent } from './account/my-profile/my-profile.component';
import { LayoutDefaultSettingsComponent } from './account/settings/layout-default/layout-default-settings.component';
import { PermissionSettingsComponent } from './account/settings/permission/permission-settings.component';
import { GeneralMeetingOverviewComponent } from './general-meeting-overview/general-meeting-overview.component';
import { GeneralMeetingRegistrationPrintComponent } from './general-meeting-registration-print/general-meeting-registration-print.component';
import { GeneralMeetingComponent } from './general-meeting/general-meeting.component';
import { GateRegisterProxiesDialog } from './general-meeting/gm-gate/gate-register-proxies/gate-register-proxies.dialog';
import { GmGateComponent } from './general-meeting/gm-gate/gm-gate.component';
import { GmShareholdersViewComponent } from './general-meeting/gm-shareholders/gm-shareholders-view/gm-shareholders-view.component';
import { GmShareholdersComponent } from './general-meeting/gm-shareholders/gm-shareholders.component';
import { HomeComponent } from './home.component';
import { AlertEditDialogComponent } from './notification-settings/alerts/alert-edit-dialog/alert-edit-dialog.component';
import { AlertParametersFormComponent } from './notification-settings/alerts/alert-edit-dialog/alert-parameters-form/alert-parameters-form.component';
import { AlertsComponent } from './notification-settings/alerts/alerts.component';
import { NotificationSettingsComponent } from './notification-settings/notification-settings.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ReportsFormComponent } from './reports/form/reports-form.component';
import { ReportsComponent } from './reports/reports.component';
import { ReportsViewComponent } from './reports/view/reports-view.component';
import { SearchComponent } from './search/search.component';
import { LoginComponent } from './security/login/login.component';
import { ShareholdersFormComponent } from './shareholders/form/shareholders-form.component';
import { ShareholdersComponent } from './shareholders/shareholders.component';
import { ShareholdersViewComponent } from './shareholders/view/shareholders-view.component';
import { TradersFormComponent } from './traders/form/traders-form.component';
import { TradersComponent } from './traders/traders.component';
import { TradersViewComponent } from './traders/view/traders-view.component';
import { TransactionsFormComponent } from './transactions/form/transactions-form.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { TransactionsViewComponent } from './transactions/view/transactions-view.component';
import { UsersFormComponent } from './users/form/users-form.component';
import { UsersComponent } from './users/users.component';
import { UsersViewComponent } from './users/view/users-view.component';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        IgxGridModule,
        TranslatePipe,
        TranslateDirective,
        DirectivesModule,
        ComponentsModule,
        PipesModule,
        Gridster,
        GridsterItem
    ],
    declarations: [
        HomeComponent,
        LoginComponent,
        ShareholdersComponent,
        TradersComponent,
        TransactionsComponent,
        ReportsComponent,
        LayoutDefaultSettingsComponent,
        PermissionSettingsComponent,
        SearchComponent,
        ShareholdersFormComponent,
        ReportsFormComponent,
        TransactionsFormComponent,
        TradersFormComponent,
        ShareholdersViewComponent,
        TradersViewComponent,
        TransactionsViewComponent,
        UsersComponent,
        UsersFormComponent,
        UsersViewComponent,
        ReportsViewComponent,
        GeneralSettingsComponent,
        GeneralMeetingComponent,
        GeneralMeetingOverviewComponent,
        MyProfileComponent,
        GmShareholdersComponent,
        GmGateComponent,
        GateRegisterProxiesDialog,
        NotificationsComponent,
        AlertsComponent,
        AlertEditDialogComponent,
        AlertParametersFormComponent,
        NotificationSettingsComponent,
        GmShareholdersViewComponent,
        GeneralMeetingRegistrationPrintComponent
    ],
    exports: [
        HomeComponent,
        LoginComponent,
        ShareholdersComponent,
        TradersComponent,
        TransactionsComponent,
        ReportsComponent,
        LayoutDefaultSettingsComponent,
        PermissionSettingsComponent,
        SearchComponent,
        ShareholdersFormComponent,
        ReportsFormComponent,
        TransactionsFormComponent,
        TradersFormComponent,
        ShareholdersViewComponent,
        TradersViewComponent,
        TransactionsViewComponent,
        UsersComponent,
        UsersFormComponent,
        UsersViewComponent,
        ReportsViewComponent,
        GeneralSettingsComponent,
        GeneralMeetingComponent,
        GeneralMeetingOverviewComponent,
        MyProfileComponent,
        GmShareholdersComponent,
        GmGateComponent,
        NotificationsComponent,
        AlertsComponent,
        AlertEditDialogComponent,
        AlertParametersFormComponent,
        NotificationSettingsComponent
    ]
})
export class ViewsModule {}
